import {
  Directive,
  effect,
  inject,
  input,
  signal,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AuthService } from '@core/services/auth/auth.service';
import { PermissionsService } from '@core/services/permissions.service';
import { GlobalPermissionsEnum } from '@generated/permissions.enum';

@Directive({
  selector: '[hasPermission]',
  standalone: true,
})
export class HasPermissionDirective {
  viewContainerRef = inject(ViewContainerRef);
  templateRef = inject(TemplateRef);
  permissionsService = inject(PermissionsService);
  authService = inject(AuthService);

  permissions = input.required<`${GlobalPermissionsEnum}`[] | GlobalPermissionsEnum[]>({
    alias: 'hasPermission',
  });

  private hasView = signal(false);

  constructor() {
    effect(() => {
      this.authService.authenticatedUser();
      this.authService.databaseRoleReactive();
      this.authService.pipeRoleReactive();
      const perms = this.permissions();

      const authorized = perms.length <= 0 || this.permissionsService.hasAnyPermission(perms, {});

      if (authorized && !this.hasView()) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
        this.hasView.set(true);
      } else if (!authorized && this.hasView()) {
        this.viewContainerRef.clear();
        this.hasView.set(false);
      }
    });
  }
}
